import React, { useEffect, useRef } from 'react';

const Testimonial = () => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const initializeOwl = () => {
      if (window.$ && window.$('.three-item-carousel').owlCarousel) {
        window.$('.three-item-carousel').owlCarousel({
          loop: true,
          margin: 30,
          items: 3,
          autoplay: true,
          smartSpeed: 1000,
          dots: true,
          nav: false,
          responsive: {
            0: { items: 1 },
            768: { items: 2 },
            992: { items: 3 }
          }
        });
      } else {
        setTimeout(initializeOwl, 300); // Retry if not ready
      }
    };

    initializeOwl();
  }, []);

  const testimonials = [
    {
      name: 'Atalia Helena',
      image: '/assets/images/resource/testimonial-5.png',
      text: 'I had a tight deadline for translating some legal documents, and Wications delivered ahead of schedule without compromising on quality. Their professionalism and attention to detail are unmatched. Highly recommend!'
    },
    {
      name: 'Daniel Macron',
      image: '/assets/images/resource/testimonial-7.png',
      text: 'I was overwhelmed by the need for effective communication in multiple languages. Wications made the process seamless, offering insights and perfect translations that felt natural and engaging to my new audience.'
    },
    {
      name: 'William Brandon',
      image: '/assets/images/resource/testimonial-5.png', // reused image
      text: 'I’ve worked with many translators, but Wications stands out for their attention to detail and commitment to quality. They didn’t just translate my text; they understood its purpose and adapted it perfectly for my audience.'
    },
    {
      name: 'Daniel Macron',
      image: '/assets/images/resource/testimonial-7.png', // reused image
      text: 'I needed certified translations for sensitive documents, and Wications handled everything with the utmost professionalism. I felt confident in their ability to maintain confidentiality while delivering impeccable results.'
    }
  ];

  return (
    <section className="testimonial-section centred pb_120 pt-5">
      <div className="shape">
        <div
          className="shape-1 rotate-me"
          style={{ backgroundImage: 'url(assets/images/shape/shape-45.png)' }}
        ></div>
        <div
          className="shape-2"
          style={{ backgroundImage: 'url(assets/images/shape/shape-46.png)' }}
        ></div>
      </div>
      <div className="auto-container">
        <div data-animation-box className="sec-title mb_55">
          <span
            className="sub-title overlay-anim-white-bg"
            data-animation-text
            data-animation="overlay-animation"
          >
            Testimonials
          </span>
          <h2>Love from Users</h2>
        </div>
        <div
          className="three-item-carousel owl-carousel owl-theme owl-nav-none dots-style-one"
          ref={carouselRef}
        >
          {testimonials.map((item, idx) => (
            <div className="testimonial-block-one" key={idx}>
              <div className="inner-box">
                <figure className="thumb-box">
                  <img src={item.image} alt={item.name} />
                </figure>
                <h4>{item.name}</h4>
                <span className="designation">Happy Client</span>
                <ul className="rating">
                  {[...Array(5)].map((_, i) => (
                    <li key={i}>
                      <i className="icon-19"></i>
                    </li>
                  ))}
                </ul>
                <p>“{item.text}”</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;